import { useMutation } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UsePayoutReminderEmailBulkMutationProps = {
	checkedUsers: number[]
	closeBulkPayoutReminderEmailModal: () => void
}

export const usePayoutReminderEmailBulkMutation = ({
	checkedUsers,
	closeBulkPayoutReminderEmailModal
}: UsePayoutReminderEmailBulkMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()

	const { mutate: payoutReminderEmailBulkMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post('/accounts/send_payout_method_reminder_email/', {
				ids: checkedUsers
			})
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Payout method reminder email sent')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			closeBulkPayoutReminderEmailModal()
		}
	})

	return {
		payoutReminderEmailBulkMutation
	}
}
